// extracted by mini-css-extract-plugin
export default {"highestPowerUsageDeviceCardContainer":"highest-power-usage-device-card_highestPowerUsageDeviceCardContainer__WoWX0"};